import { CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID } from '@src/config/env'
import { checkApiBlocked } from '@src/quince-site-common/src/utils/checkApiBlocked'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

export const checkIfGtmIsBlocked = () => {
  checkApiBlocked(`https://www.googletagmanager.com/gtm.js?id=${CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID}`)
    .then(({ blocked, errorType }) => {
      if (blocked) {
        trackEvent(TELEMETRY_EVENT_NAMES.API_RESPONSE, {
          apiName: 'gtmScript',
          status: 'blocked',
          errorType,
        })
      }
    })
    .catch(() => null)
}
